import gql from 'graphql-tag';

const SEND_LISTING_SHARE_MUTATION = gql`
  mutation trackListingShare($listingId: ID!) {
    trackListingShare(listingId: $listingId)
  }
`;

export const trackListingShare = client => listingId =>
  client.mutate({
    mutation: SEND_LISTING_SHARE_MUTATION,
    variables: { listingId }
  });
